import request from '@/utils/request'

let ServiceApi = {

  /*服务列表*/
  list(data) {
    return request._post('/shop/plus.service.Index/index', data);
},
/*添加服务*/
add(data) {
    return request._post('/shop/plus.service.Index/add', data);
},
/*修改服务*/
edit(data) {
    return request._post('/shop/plus.service.Index/edit', data);
},
/*删除服务*/
del(data) {
    return request._post('/shop/plus.service.Index/del', data);
},
tx(data) {
    return request._post('/shop/plus.service.Index/tx', data);
},
/*服务详情*/
detail(data) {
  return request._post('/shop/plus.service.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.service.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.service.Setting/getSetting', data, errorback);
    },




      /*服务列表*/
  listDeclare(data) {
    return request._post('/shop/plus.declares.Index/index', data);
},
/*添加服务*/
addDeclare(data) {
    return request._post('/shop/plus.declares.Index/add', data);
},
/*修改服务*/
editDeclare(data) {
    return request._post('/shop/plus.declares.Index/edit', data);
},
/*删除服务*/
delDeclare(data) {
    return request._post('/shop/plus.declares.Index/del', data);
},
/*服务详情*/
detailDeclare(data) {
  return request._post('/shop/plus.declares.Index/detail', data);
},



      /*服务列表*/
      listInfo(data) {
        return request._post('/shop/plus.declares.Info/index', data);
    },
    /*添加服务*/
    addInfo(data) {
        return request._post('/shop/plus.declares.Info/add', data);
    },
    /*修改服务*/
    editInfo(data) {
        return request._post('/shop/plus.declares.Info/edit', data);
    },
    /*删除服务*/
    delInfo(data) {
        return request._post('/shop/plus.declares.Info/del', data);
    },
    /*服务详情*/
    detailInfo(data) {
      return request._post('/shop/plus.declares.Info/detail', data);
    },
    passCanel(data) {
        return request._post('/shop/plus.declares.Info/passCanel', data);
      },

      setDeclare(data){
            return request._post('/shop/plus.declares.Info/setDeclare', data);
          },
}
export default ServiceApi;



// WEBPACK FOOTER //
// ./src/api/service.js